import React from "react";
import Validation from "errors/Validation";
import { toArray } from "lib/converters";
import PropTypes from "prop-types";

//TODO: Выглядит как говно. Хз как по другому написать
const InputMessage = ({ message, error, flattenName, frontendValidation }) => {
    let inputMessage = null;

    if (message) {
        inputMessage = <div className="form-input__message ">{message}</div>;
    }

    if (error instanceof Validation && error.errors[flattenName]) {
        inputMessage = (
            <div className="form-input__message form-input__message_error">
                {toArray(error.errors[flattenName]).join(`, `)}
            </div>
        );
    }

    if (frontendValidation) {
        inputMessage = (
            <div className="form-input__message form-input__message_error">
                {frontendValidation}
            </div>
        );
    }

    return inputMessage;
};

InputMessage.propTypes = {
    frontendValidation: PropTypes.string,
    message: PropTypes.string,
    error: PropTypes.array,
    flattenName: PropTypes.string,
};

export default InputMessage;
